import { Record } from 'immutable';

export class NewsletterFormRecord extends Record({
  email: '',
}) {
  email: string;
}
